import { MenuNode } from '../submodules/angular-ui-common/base-types';
import { Icon } from '../submodules/angular-ui-common/icon';
import { BASE_NAVIGATION_TREE } from '../submodules/angular-ui-common/navigation-tree';
import { IAM_NAVIGATION_TREE } from '../submodules/iam-ui/navigation-tree';

export const NAVIGATION_TREE: MenuNode[] = [
  ...BASE_NAVIGATION_TREE, 
  {
    id: "nim_dashboard",
    label: "MENU.DASHBOARD",
    shortLabel: "MENU.DASHBOARD",
    icon: Icon.dashboard,
    url: '/private/meeting/home',
    requiredAuthorities: ['NIM__DASHBOARD__READ'],
    disabled: false,
    showInPublicMenu: false,
    showInPrivateMenu: true,
    navigable: true,
  },
  {
    id: "nim_members",
    label: "Prenotazioni",
    shortLabel: "Prenotazioni",
    icon: Icon.calendarCheck,
    url: '/private/reservations/slots',
    requiredAuthorities: [/*'NIM__MEMBERS__READ'*/],
    disabled: false,
    showInPublicMenu: false,
    showInPrivateMenu: true,
    navigable: true,
    children: [
      {
          id: "nim_edit_member",
          label: "Gestione Slot",
          icon: Icon.pencil,
          url: '/private/reservations/slots/:id/edit',
          requiredAuthorities: [/*'NIM__MEMBERS__READ'*/],
          disabled: false,
          showInPublicMenu: false,
          showInPrivateMenu: false,
          navigable: true
      }
  ]
  },
  ...IAM_NAVIGATION_TREE
  // {
  //   id: "settings",
  //   label: "MENU.SETTINGS",
  //   icon: Icon.cog,
  //   requiredAuthorities: [],//[], // espediente per rendere invisibile questa voce di menu
  //   disabled: false,
  //   showInPublicMenu: false,
  //   showInPrivateMenu: true,
  //   navigable: false,
  //   children: []
  // },
  // {
  //   id: "chat",
  //   label: "MENU.CHAT",
  //   icon: Icon.messageText,
  //   requiredAuthorities: [],//[], // espediente per rendere invisibile questa voce di menu
  //   disabled: false,
  //   showInPublicMenu: false,
  //   showInPrivateMenu: true,
  //   navigable: false,
  //   children: [
  //     {
  //       id: "topics",
  //       label: "MENU.CHAT.TOPICS",
  //       icon: Icon.forum,
  //       url: '/private/chat/topics',
  //       requiredAuthorities: [],
  //       disabled: false,
  //   	showInPublicMenu: false,
  //   	showInPrivateMenu: true,
  //       navigable: true,
  //       children: [
  //         {
  //           id: "messages",
  //           label: "MENU.CHAT.MESSAGES",
  //           icon: Icon.forum,
  //           url: '/private/chat/topics/:id/messages',
  //           requiredAuthorities: [],
  //           disabled: false,
  //   	    showInPublicMenu: false,
  //   	    showInPrivateMenu: false,
  //           navigable: true
  //         }
  //       ]
  //     }
  //   ]
  // }
];
